import React from 'react'
import MarketPageComponent from '../components/market'

function MarketPage() {
  return (
    <div className=''><MarketPageComponent/></div>
  )
}

export default MarketPage